var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative font-semibold cursor-pointer px-2 rounded-md transition duration-150 ease-in-out",class:_vm.getClasses,on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }